import { TGetInfrastructureMicrofrontendRequest } from 'shared/repositories/map-search-frontend/v1/get-infrastructure-microfrontend';
import { IPageData } from 'shared/store';

export function getInfrastructureMicrofrontendRequestParams(
  pageData: IPageData,
  offerId: number,
): TGetInfrastructureMicrofrontendRequest {
  return {
    dealType: pageData.dealType,
    offerType: pageData.offerType,
    offerId,
  };
}
